<template>
  <div>
    <el-dialog v-if="dialogVisible" v-el-drag-dialog :title="'会议室占用情况'" class="meet_place_dialog" :visible.sync="dialogVisible" width="1200px" :close-on-click-modal="false" :destroy-on-close="true" @close="toClose">
        <div class="meet_place_content">
            <div class="meet_place_top">
                <div class="left">
                    <div class="left_week_change">
                        <div class="change_dv" @click="changeWeekHandle('prev')"><i class="el-icon-arrow-left "></i></div>
                        <div class="change_date">{{ weekTimeArr[0] }}至{{ weekTimeArr[1] }}</div>
                        <div class="change_dv" @click="changeWeekHandle('next')"><i class="el-icon-arrow-right "></i></div>
                    </div>
                    <div class="left_week" @click="changeWeekHandle('today')">本周</div>
                </div>
                <div class="right">
                    <div>
                        <span>场地：</span>
                        <el-select v-model="siteValue" placeholder="请选择" @change="changeSite">
                            <el-option v-for="item in siteOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                        </el-select>
                    </div>
                    <div style="margin-left:10px;">
                        <span>会议室：</span>
                        <el-select v-model="roomValue" placeholder="请选择" @change="changeRoom">
                            <el-option v-for="item in roomOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div v-loading="loading" class="meet_content_main">
                <div class="meet_place_main">
                    <template v-if="!loading">
                        <div class="main_header">
                            <div class="main_time" style="padding-left: 5px;">日期时间</div>
                            <div v-for="(item,index) in weekTimeProp" :key="index" class="main_day">
                                <span>{{ item.week }}</span>
                                <span>{{ $moment(new Date(item.date)).format('MM-DD') }}</span>
                            </div>
                        </div>
                        <div class="main_right">
                            <div ref="mainContent" class="main_content">
                                <div class="main_times">
                                    <div v-for="i in hourOptions" :key="i.hour" class="main_time">{{ i.hour>=10?i.hour:'0'+i.hour }}:00</div>
                                </div>
                                <div class="main_rooms">
                                    <div v-for="(hour, hIndex) in hourOptions" :key="hIndex" class="columns_rooms_hour">
                                        <div v-for="(day, dIndex) in meetPlace.weekdays" :key="hour.hour+'_'+dIndex" :data-num="dIndex" class="columns_rooms">
                                            <div v-if="day.meetingList.length" class="wh100" :class="{'columns_rooms_active': new Date(day.weekday+ ' '+hour.hour+':00:00').getTime() > new Date().getTime()}">
                                                <template v-if="day.hours.some(h => Number(h) === hour.hour)">
                                                    <div v-for="(item,index) in weekTimeProp" :key="index" class="items wh100">
                                                        <template v-if="day.weekday === item.date">
                                                            <span v-for="(meet, mIndex) in day.meetingList" :key="dIndex+'_'+mIndex" class="wh100 dv">
                                                                <template v-if="Number(meet.tStartHour) === Number(hour.hour)">
                                                                    <div class="meet_place_item">
                                                                        <div class="meet_title">{{ meet.meetSubjedt }}</div>
                                                                        <div class="meet_time">{{ meet.tStart }}-{{ meet.tEnd }}</div>
                                                                    </div>
                                                                </template>
                                                                <template v-else-if="Number(meet.tDiffHour)>0">
                                                                    <span v-for="i in meet.tDiffHour" :key="i">
                                                                        <template v-if="Number(meet.tStartHour)+i === Number(hour.hour)">
                                                                            <div :ref="i == meet.tDiffHour ? day.weekday+'_'+hour.hour : ''" class="meet_place_item" :class="i== meet.tDiffHour ? 'rooms_can_order':''" :data-flag="i== meet.tDiffHour ? day.weekday+'_'+hour.hour : ''" :data-auto="i== meet.tDiffHour ? day.weekday+'_'+hour.hour : ''" @click="orderClick(day.weekday+'_'+hour.hour, true)">
                                                                                <div class="meet_title">{{ meet.meetSubjedt }}</div>
                                                                                <div class="meet_time">{{ meet.tStart }}-{{ meet.tEnd }}</div>
                                                                            </div>
                                                                        </template>
                                                                    </span>
                                                                </template>
                                                            </span>
                                                        </template>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div class="items wh100">
                                                        <template v-if="new Date(day.weekday+ ' '+hour.hour+':59:59').getTime() > new Date().getTime()">
                                                            <div v-if="(new Date(day.weekday+ ' '+meetPlace.rbegintime+':00').getTime() < new Date(day.weekday+ ' '+hour.hour+':00:00').getTime()) && (new Date(day.weekday+ ' '+meetPlace.rendtime+':00').getTime() > new Date(day.weekday+ ' '+hour.hour+':00:00').getTime())" :ref="day.weekday+'_'+hour.hour" :data-flag="day.weekday+'_'+hour.hour" class="rooms_can_order" @click="orderClick(day.weekday+'_'+hour.hour)">
                                                                可预约
                                                            </div>
                                                            <div v-else class="rooms_not_order">
                                                                不在开放周期
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            <div class="rooms_not_order">不可预约</div>
                                                        </template>
                                                    </div>
                                                </template>
                                            </div>
                                            <div v-else class="wh100">
                                                <!-- 是否在开放周期 星期 -->
                                                <template v-if="meetPlace.dayNumbers.indexOf(dIndex+1) !== -1">
                                                    <!-- 是否在当前时间之后 -->
                                                    <template v-if="new Date(day.weekday+ ' '+hour.hour+':59:59').getTime() > new Date().getTime()">
                                                    <!-- <template v-if="(new Date(day.weekday+ ' '+meetPlace.rbegintime+':00').getTime() < new Date(day.weekday+ ' '+hour.hour+':00:00').getTime()) && (new Date(day.weekday+ ' '+meetPlace.rendtime+':00').getTime() > new Date(day.weekday+ ' '+hour.hour+':00:00').getTime())"> -->
                                                        <!-- 是否在开放周期 时间 -->
                                                        <div v-if="(new Date(day.weekday+ ' '+meetPlace.rbegintime+':00').getTime() < new Date(day.weekday+ ' '+hour.hour+':00:00').getTime()) && (new Date(day.weekday+ ' '+meetPlace.rendtime+':00').getTime() > new Date(day.weekday+ ' '+hour.hour+':00:00').getTime())" :ref="day.weekday+'_'+hour.hour" :data-flag="day.weekday+'_'+hour.hour" class="rooms_can_order" @click="orderClick(day.weekday+'_'+hour.hour)">
                                                            可预约
                                                        </div>
                                                        <div v-else class="rooms_not_order">
                                                            不在开放周期
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <div class="rooms_not_order">不可预约</div>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <div class="rooms_not_order">不在开放周期</div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button v-pageBtn-lbl="'cancel'" icon="el-icon-close" @click="toClose">取 消</el-button>
            <el-button v-pageBtn-lbl="'save'" icon="el-icon-check" type="primary" @click="saveClick">保 存</el-button>
        </span>
    </el-dialog>
    </div>
</template>

<script>
const moment = require('moment')
export default {
    filters: {
        timeFormat(val) {
            if (val) {
                return moment(val).format('YYYY-MM-DD HH:mm')
            } else {
                return ''
            }
        }
    },
    components: {},
    props: {
    },
    data() {
        return {
            i18npkg: 'hygl',
            moduleCode: 'hyap',
            loginUser: this.$store.getters.loginUser,
            dialogVisible: false,
            loading: false,
            callback: null,
            formVo: {},
            siteOptions: [], // 场地
            siteValue: '',
            roomOptions: [], // 会议室
            roomValue: '',
            weekTimeArr: [],
            meetPlace: [],
            weekTimeProp: [],
            hourOptions: [], // 24小时
            activeDay: '' // 记录第一次点击 可预约的 日期

        }
    },
    computed: {},
    watch: {},
    created() {
        this.$bus.on('openMeetPlaceDialog', this.openMeetPlaceDialog)
    },
    beforeDestroy() {
        this.$bus.off('openMeetPlaceDialog', this.openMeetPlaceDialog)
    },
    mounted() {},
    methods: {
        openMeetPlaceDialog(vo, callback) {
            this.formVo = vo
            this.callback = callback
            this.dialogVisible = true
            this.changeWeekHandle('today')
        },
        changeWeekHandle(type) {
            var startDate = ''
            var endDate = ''
            if (type === 'prev') {
                startDate = moment(this.weekTimeArr[0]).week(moment(this.weekTimeArr[0]).week() - 1).startOf('weeks').format('YYYY-MM-DD')
                endDate = moment(this.weekTimeArr[0]).week(moment(this.weekTimeArr[0]).week() - 1).endOf('weeks').format('YYYY-MM-DD')
            } else if (type === 'next') {
                startDate = moment(this.weekTimeArr[0]).week(moment(this.weekTimeArr[0]).week() + 1).startOf('weeks').format('YYYY-MM-DD')
                endDate = moment(this.weekTimeArr[0]).week(moment(this.weekTimeArr[0]).week() + 1).endOf('weeks').format('YYYY-MM-DD')
            } else if (type === 'today') {
                startDate = moment().startOf('weeks').format('YYYY-MM-DD')
                endDate = moment().endOf('weeks').format('YYYY-MM-DD')
            }
            this.weekTimeArr = [startDate, endDate]
            const weekTimeProp = []
            const hourOptions = []
            for (let index = 0; index < 7; index++) {
                let obj = {
                    date: moment(startDate).add(index, 'days').format('YYYY-MM-DD'),
                    week: moment(startDate).add(index, 'days').format('dddd').replace('星期', '周'),
                    day: moment(startDate).add(index, 'days').format('DD'),
                    isToday: moment(startDate).add(index, 'days').format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')
                }
                weekTimeProp.push(obj)
            }
            for (let index = 1; index < 24; index++) {
                let obj = {
                    hour: index,
                    hasMeetDay: '', // 有会议的日期
                    hasMeetTime: '' // 有会议的时间(记录小时)
                }
                hourOptions.push(obj)
            }
            this.weekTimeProp = weekTimeProp
            this.hourOptions = hourOptions
            this.getSiteData()
        },
        // 查寻所有的场地
        getSiteData() {
            this.loading = true
            this.$http({
                method: 'POST',
                url: 'hygl/site/querydata',
                contentType: 'application/x-www-form-urlencoded',
                data: [
                    { compare: '=', field: 'status', merge: true, value: 1},
                    { compare: '=', field: 'orgCode', merge: true, value: this.loginUser.orgCode}
                ],
                params: { orderBy: 'orderNo asc' }
            }).then((res) => {
                if (res.code === 'success') {
                    const siteList = res.body.listdata
                    this.siteOptions = siteList
                    if (siteList[0]) {
                        this.siteValue = siteList[0].id
                        this.getMeetingRoomData(this.weekTimeArr[0], this.weekTimeArr[1])
                    }
                }
            })
        },
        changeSite(val) {
            this.siteValue = val
            this.roomValue = ''
            this.getMeetingRoomData(this.weekTimeArr[0], this.weekTimeArr[1])
        },
        changeRoom(val) {
            this.roomValue = val
            this.getMeetingRoomData(this.weekTimeArr[0], this.weekTimeArr[1])
        },
        /**
         * 该场地下的会议室信息
         */
        getMeetingRoomData(startDate, endDate, cbFunc = null) {
            var temp = { // 假数据
                'body': {
                    'listdata': [
                        {
                            'approve': 1,
                            'deviceProperties': '投影仪,大屏幕,话筒',
                            'id': 'f9b06f962ede4255b08d54e4c804fdbd',
                            'layoutName': 'U型桌-长边共10人，短边共1人',
                            'meetImgname': null,
                            'meetImgurl': null,
                            'name': '12楼会议室',
                            'numPeople': 100,
                            'openday': '周一,周二,周三,周四,周五,周日',
                            'rbegintime': '08:00',
                            'rendtime': '20:30',
                            'serviceProperties': '矿泉水,下午茶,水果',
                            'weekdays': [
                                {
                                    'meetingList': [],
                                    'weekday': '2025-02-10'
                                },
                                {
                                    'meetingList': [],
                                    'weekday': '2025-02-11'
                                },
                                {
                                    'meetingList': [
                                        {
                                            'agentId': null,
                                            'agentPhone': null,
                                            'agentUser': null,
                                            'applayName': '黄多',
                                            'applyUserid': 'bf7c7d7ec270483886e86edbba5b30f2',
                                            'attendDept': null,
                                            'attendLeader': null,
                                            'attendUserId': null,
                                            'attendUserName': null,
                                            'beginTime': '2025-02-12 18:10:00',
                                            'createTime': '2025-02-12 18:10:57',
                                            'departmentUser': '综合部',
                                            'deviceProperties': null,
                                            'endTime': '2025-02-12 18:50:00',
                                            'groupId': null,
                                            'id': 'c2cd21076b214967a8c150eaea9daa3a',
                                            'isParent': null,
                                            'meetDetails': '会议内容会议内容会议内容',
                                            'meetName': '12楼会议室',
                                            'meetRoomId': 'f9b06f962ede4255b08d54e4c804fdbd',
                                            'meetSubjedt': '会议主题会议主题',
                                            'numPeople': 100,
                                            'orgCode': 'tsys',
                                            'orgName': '广东易臣信息技术有限公司',
                                            'passenger': {
                                                'busiDataId': '',
                                                'status': null
                                            },
                                            'phone': '13700000009',
                                            'preordainType': '0',
                                            'remark': null,
                                            'remindType': null,
                                            'serviceProperties': null,
                                            'site': null,
                                            'status': 1,
                                            'userName': null,
                                            'week': null,
                                            'weekProperties': '周一,周二,周三,周四,周五'
                                        },
                                        {
                                            'agentId': null,
                                            'agentPhone': null,
                                            'agentUser': null,
                                            'applayName': '黄多',
                                            'applyUserid': 'bf7c7d7ec270483886e86edbba5b30f2',
                                            'attendDept': null,
                                            'attendLeader': null,
                                            'attendUserId': null,
                                            'attendUserName': null,
                                            'beginTime': '2025-02-12 19:00:00',
                                            'createTime': '2025-02-12 15:52:01',
                                            'departmentUser': '工程部',
                                            'deviceProperties': '投影仪,大屏幕,话筒',
                                            'endTime': '2025-02-12 20:30:00',
                                            'groupId': null,
                                            'id': '0d53dc9a80f04fbeb74ca5bc54d3f3bd',
                                            'isParent': null,
                                            'meetDetails': '会议内容会议内容会议内容会议内容',
                                            'meetName': '12楼会议室',
                                            'meetRoomId': 'f9b06f962ede4255b08d54e4c804fdbd',
                                            'meetSubjedt': '会议室申请20250205UPRN',
                                            'numPeople': 100,
                                            'orgCode': 'tsys',
                                            'orgName': '广东易臣信息技术有限公司',
                                            'passenger': {
                                                'busiDataId': '0d53dc9a80f04fbeb74ca5bc54d3f3bd',
                                                'status': 1
                                            },
                                            'phone': '13700000009',
                                            'preordainType': '0',
                                            'remark': '提前5分钟入场',
                                            'remindType': 0,
                                            'serviceProperties': '矿泉水,下午茶,水果',
                                            'site': '中公教育大厦',
                                            'status': 2,
                                            'userName': null,
                                            'week': '周一,周二,周三,周四,周五',
                                            'weekProperties': '周一,周二,周三,周四,周五'
                                        }
                                    ],
                                    'weekday': '2025-02-12'
                                },
                                {
                                    'meetingList': [],
                                    'weekday': '2025-02-13'
                                },
                                {
                                    'meetingList': [],
                                    'weekday': '2025-02-14'
                                },
                                {
                                    'meetingList': [],
                                    'weekday': '2025-02-15'
                                },
                                {
                                    'meetingList': [],
                                    'weekday': '2025-02-16'
                                }
                            ]
                        },
                        {
                            'approve': 0,
                            'deviceProperties': '投影仪,话筒',
                            'id': '04c5b93850c84f5cb9a8895ab3716948',
                            'layoutName': '圆型桌-8人',
                            'meetImgname': null,
                            'meetImgurl': null,
                            'name': '小会议室',
                            'numPeople': 20,
                            'openday': '周二,周三,周六,周日',
                            'rbegintime': '09:00',
                            'rendtime': '18:00',
                            'serviceProperties': '矿泉水',
                            'weekdays': [
                                {
                                    'meetingList': [],
                                    'weekday': '2025-02-10'
                                },
                                {
                                    'meetingList': [],
                                    'weekday': '2025-02-11'
                                },
                                {
                                    'meetingList': [],
                                    'weekday': '2025-02-12'
                                },
                                {
                                    'meetingList': [],
                                    'weekday': '2025-02-13'
                                },
                                {
                                    'meetingList': [],
                                    'weekday': '2025-02-14'
                                },
                                {
                                    'meetingList': [],
                                    'weekday': '2025-02-15'
                                },
                                {
                                    'meetingList': [],
                                    'weekday': '2025-02-16'
                                }
                            ]
                        }
                    ]
                },
                'code': 'success',
                'message': '处理成功！'
            }
            this.loading = true
            const _this = this
            this.$http({
                method: 'GET',
                url: 'hygl/meeting/queryMeetingRoomReserveInfo',
                contentType: 'application/x-www-form-urlencoded',
                params: {
                    startDate: startDate,
                    endDate: endDate,
                    siteId: this.siteValue
                }
            }).then((res) => {
                if (res.code === 'success') {
                    // var list = temp.body.listdata
                    var list = res.body.listdata
                    const dayMap = { '周一': '1', '周二': '2', '周三': '3', '周四': '4', '周五': '5', '周六': '6', '周日': '7'}
                    list = list.map((item) => {
                        item.dayNumbers = item.openday.split(',').map(day => dayMap[day]).join(',')
                        if (item.weekdays && item.weekdays.length) {
                            if (item.weekdays[0].meetingList) {
                                item.weekdays = item.weekdays.map(week => {
                                    let hours = []
                                    week.meetingList = week.meetingList.reduce((acc, curr) => {
                                        curr.tStart = moment(new Date(curr.beginTime)).format('HH:mm')
                                        curr.tStartHour = moment(new Date(curr.beginTime)).format('HH')
                                        curr.tStartMinute = moment(new Date(curr.beginTime)).format('mm')
                                        curr.tEnd = moment(new Date(curr.endTime)).format('HH:mm')
                                        curr.tEndMinute = moment(new Date(curr.endTime)).format('mm')
                                        curr.tEndHour = moment(new Date(curr.endTime)).format('HH')
                                        curr.tDiffHour = curr.tEndHour - curr.tStartHour

                                        // 计算两个时间的差值
                                        curr.tDiff = moment(new Date(curr.endTime)).diff(moment(new Date(curr.beginTime)), 'minute')

                                        if (acc.length && acc.some(accItem => (new Date(accItem.beginTime).getTime() <= new Date(curr.beginTime).getTime() && new Date(accItem.endTime).getTime() >= new Date(curr.beginTime).getTime()) ||
                                            (new Date(accItem.beginTime).getTime() >= new Date(curr.beginTime).getTime() && new Date(accItem.beginTime).getTime() <= new Date(curr.endTime).getTime())
                                        )) {
                                            acc = [...acc]
                                        } else {
                                            acc = [...acc, curr]
                                        }
                                        return acc
                                    }, [])

                                    week.meetingList = week.meetingList.map((meeting) => {
                                        // 处理 hourOptions
                                        _this.hourOptions.forEach(hour => {
                                            if (Number(hour.hour) === Number(meeting.tStartHour)) {
                                                hour.hasMeetDay += moment(new Date(meeting.beginTime)).format('YYYY-MM-DD') + ','
                                                hour.hasMeetTime += meeting.tStartHour + ','
                                            } else {
                                                if (meeting.tDiffHour > 0) {
                                                    for (let i = 0; i < meeting.tDiffHour + 1; i++) {
                                                        if (Number(hour.hour) === Number(meeting.tStartHour) + i) {
                                                            hour.hasMeetTime += Number(meeting.tStartHour) + i + ','
                                                        }
                                                    }
                                                }
                                            }
                                        })

                                        if (meeting.tDiffHour > 0) {
                                            for (let i = 0; i < meeting.tDiffHour + 1; i++) {
                                                hours.push(Number(meeting.tStartHour) + i)
                                            }
                                        } else {
                                            hours.push(meeting.tStartHour)
                                        }

                                        return meeting
                                    })
                                    // hours 去重
                                    week.hours = [...new Set(hours)]
                                    return week
                                })
                            }
                        }
                        return item
                    })

                    console.log('this.hourOptions', this.hourOptions)
                    console.log('this.weekTimeProp', this.weekTimeProp)
                    if (list.length) {
                        this.roomOptions = list
                        if (!this.roomValue) {
                            this.roomValue = list[0].id
                            this.meetPlace = list[0]
                        } else {
                            this.meetPlace = list.filter(item => item.id === this.roomValue)[0]
                        }
                    } else {
                        this.roomOptions = []
                    }
                    console.log('this.meetPlace', this.meetPlace)
                } else {
                    this.$message.error(res.message)
                }
            }).finally(() => {
                this.loading = false
                setTimeout(() => {
                    // 删除 所有 .columns_rooms下的 .items 的 firstElementChild==null的元素
                    document.querySelectorAll('.columns_rooms .items').forEach(item => {
                        if (!item.firstElementChild) {
                            item.remove()
                        }
                    })
                    this.$nextTick(() => {
                        this.$refs.mainContent.scrollTop = 475
                    })
                }, 200)
            })
        },
        // str: 2020-09-21_1，flag: true/false 是否在已有的会议时间段内预约
        orderClick(str, flag = false) {
            console.log('str', str)

            let tempDay = str.split('_')[0]
            if (this.activeDay) { // 第二次点击
                if (this.activeDay === str) return // 如果点击的是同一天，并且是同一个时间段，则不执行
                if (this.activeDay.split('_')[0] === tempDay) { // 如果点击的是同一天
                    // 同一天且不同时间段，则改变其中间全部的背景色
                    let num = (Number(str.split('_')[1]) - Number(this.activeDay.split('_')[1]))
                    if (num > 0) {
                        for (let i = 0; i < num + 1; i++) {
                            this.$refs[this.activeDay.split('_')[0] + '_' + (Number(this.activeDay.split('_')[1]) + i)][0].style.backgroundColor = '#409eff'
                            this.$refs[this.activeDay.split('_')[0] + '_' + (Number(this.activeDay.split('_')[1]) + i)][0].style.color = '#fff'
                            this.$refs[this.activeDay.split('_')[0] + '_' + (Number(this.activeDay.split('_')[1]) + i)][0].setAttribute('order', 'order')
                        }
                    } else {
                        for (let i = 0; i < Math.abs(num) + 1; i++) {
                            this.$refs[str.split('_')[0] + '_' + (Number(str.split('_')[1]) + i)][0].style.backgroundColor = '#409eff'
                            this.$refs[str.split('_')[0] + '_' + (Number(str.split('_')[1]) + i)][0].style.color = '#fff'
                            this.$refs[this.activeDay.split('_')[0] + '_' + (Number(this.activeDay.split('_')[1]) + i)][0].setAttribute('order', 'order')
                        }
                    }
                    this.activeDay = ''
                } else {
                    // 清除其他颜色
                    clear()
                    setTimeout(() => {
                        this.activeDay = str
                        if (flag) {
                            this.$refs[str][0].style.backgroundColor = '#ea2e2e'
                            this.$refs[str][0].style.color = '#fff'
                        } else {
                            this.$refs[str][0].style.backgroundColor = '#409eff'
                            this.$refs[str][0].style.color = '#fff'
                        }
                        this.$refs[str][0].setAttribute('order', 'order')
                    }, 10)
                }
            } else {
                clear()
                setTimeout(() => {
                    this.activeDay = str
                    if (flag) {
                        this.$refs[str][0].style.backgroundColor = '#ea2e2e'
                        this.$refs[str][0].style.color = '#fff'
                    } else {
                        this.$refs[str][0].style.backgroundColor = '#409eff'
                        this.$refs[str][0].style.color = '#fff'
                    }
                    this.$refs[str][0].setAttribute('order', 'order')
                }, 10)
            }
            function clear() {
                let arr = document.querySelectorAll('.rooms_can_order')
                arr.forEach(item => {
                    if (item.getAttribute('data-flag') === item.getAttribute('data-auto')) {
                        item.style.backgroundColor = '#409eff'
                        item.style.color = '#fff'
                    } else {
                        item.style.backgroundColor = '#fff'
                        item.style.color = '#000'
                    }
                    item.setAttribute('order', '')
                })
            }
        },
        // 保存
        saveClick() {
            // 获取 含有order属性的元素
            let arr = document.querySelectorAll('.rooms_can_order[order="order"]')
            if (arr.length === 0) {
                this.callback([], this.meetPlace)
                this.toClose()
                return
            }
            let timeArr = []
            arr.forEach(item => {
                timeArr.push(item.getAttribute('data-flag'))
            })
            timeArr = timeArr.map(item => {
                return item.split('_')[0] + ' ' + item.split('_')[1] + ':00:00'
            })

            this.callback([timeArr[0], timeArr[timeArr.length - 1]], this.meetPlace)
            this.toClose()
        },
        // 关闭
        toClose() {
            this.dialogVisible = false
            this.activeDay = ''
            this.siteValue = ''
            this.roomValue = ''
        }
    }
}
</script>

<style scoped lang="scss">
.meet_place_dialog /deep/.el-dialog .el-dialog__body{
    padding-top: 10px;
}
.meet_place_dialog /deep/.el-dialog{
    margin-top: 4vh !important;
}
.meet_place_top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
        display: flex;
        align-items: center;
        .left_week_change {
            display: flex;

            .change_dv {
                width: 30px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 3px;
                background: #eff1f5;
                cursor: pointer;
            }
            .change_date {
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0 5px;
                padding: 0 8px;
                color: #666;
                background: #eff1f5;
            }
        }
        .left_week {
            margin-left: 10px;
            color: #3892e6;
            cursor: pointer;
        }
    }
    .right {
        display: flex;
        align-items: center;
    }
}
.meet_content_main {
    width: 100%;
    margin-top: 10px;
    min-height: 680px;

    .meet_place_main {
        display: flex;
        background-color: #eff1f5;
        flex-direction: column;
        padding: 10px;
        .main_header {
            display: flex;
            width: 100%;
            height: 40px;
            font-size: 14px;
        }
        .main_right {
            flex: 1;

        }
    }
    .main_time {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        width: 100%;
        height: 50px;
        width: 32px;
        color: #999999;
        margin-bottom: 10px;
    }
    .main_day {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
        font-size: 15px;
        color: #333;
        font-weight: 600;
        background: #fff;
        margin-left: 10px;
        border-radius: 5px;
    }
    .main_content {
        display: flex;
        height: 600px;
        overflow: auto;
        margin-top: 20px;
        /* 设置滚动条thumb（滑块）的颜色 */
        &::-webkit-scrollbar-thumb {
            background-color: #d2d4da;
            border-radius: 6px;
        }

        /* 增加滚动条的宽度，高度 */
        &::-webkit-scrollbar {
            width: 0px;
            height: 0px;
        }

        /* 设置滚动条hover时thumb的颜色 */
        &::-webkit-scrollbar-thumb:hover {
            background-color: #d2d4da;
            cursor: pointer;
        }
        .main_times {
            width: 32px;
        }
        .main_rooms {
            flex: 1;
            .columns_rooms_hour {
                display: flex;
                .columns_rooms {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 15px;
                    color: #333;
                    font-weight: 600;
                    background: #fff;
                    margin-left: 10px;
                    border-radius: 5px;
                    height: 50px;
                    margin-bottom: 10px;
                }

                .rooms_can_order {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    height: 100%;
                    border-radius: 5px;
                    color: #333;
                    font-size: 14px;
                    font-weight: 500;
                    cursor: pointer;
                    &:hover {
                        color: #fff;
                        background-color: #409eff;
                    }
                }
                .rooms_not_order {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    height: 100%;
                    background-color: #efe6e6;
                    border-radius: 5px;
                    font-size: 14px;
                    font-weight: 500;
                    cursor: default;
                }
            }
        }
        .meet_place_item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            padding: 0 10px;
            color: #fff !important;
            font-size: 15px !important;
            background-color: #409eff;
            border-radius: 5px;
            .meet_title {
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                text-align: center;
            }
            .meet_time {
                text-align: center;
            }
        }
    }
    .wh100 {
        width:100%;height:100%;
    }

}
</style>
